module.exports = __webpack_public_path__ + "static/media/tiger_color.ba7309fb.png";